class OpenAI {
    constructor(chatGPTUrl, dalleUrl) {
        this.chatGPTUrl = chatGPTUrl;
        this.dalleUrl = dalleUrl;
    }
    async createChatCompletion(messages) {
        try {
            const response = await fetch(this.chatGPTUrl, {
                method: 'POST',
                body: JSON.stringify(messages),
            });
            return response.json();
        } catch (err) {
            console.log(err);
        }
    }
    async create360Image(prompt, engine='dalle') {
        try {
            const response = await fetch(this.dalleUrl, {
                method: 'POST',
                body: JSON.stringify({prompt, engine}),
            });
            return response.json();
        } catch (err) {
            console.log(err);
        }
    }
}

export default new OpenAI(
    'https://rxate6xhngfgkki6dcjfralwiu0opcrc.lambda-url.us-east-1.on.aws/',
    'https://xffzj3w42ge7cwh3wrp44w2ii40eoopo.lambda-url.us-east-1.on.aws/'
);
